export default {
  colors: {
    threshold: 255,
  },
  presets: {
    light: {
      primary: '#183553',
      sidebarColor: '#234E7B',
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
    },
    dark: {
      primary: '#183553',
      sidebarColor: '#234E7B',
      backgroundPrimary: '#0F0F0F',
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
}
